import { useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';
import './App.css';
import { ITurno } from './models/turno';
import TurnoItem from './components/turno-item';
import TurnoMain from './components/turno-main';
import { ITvMessage } from './models/tv-message';
import "react-image-gallery/styles/css/image-gallery.css";
import ReactPlayer from 'react-player';

const App = (): JSX.Element => {

  const [connection, setConnection] = useState<signalR.HubConnection>();
  const [isConnected, setIsConnected] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [connectionError, setConnectionError] = useState('');
  const [turnos, setTurnos] = useState<ITurno[]>([]);
  const [isCalling, setIsCalling] = useState(false);
  const [currentTurno, setCurrentTurno] = useState<ITurno | null>(null); 
  const [date, setDate] = useState('');
  const [client, setClient] = useState((window as any).domain);
  const [isProcessingQueue, setIsProcessingQueue] = useState(false);
  const [turnoIsCalling, setTurnoIsCalling] = useState<ITurno[]>([]);

  let callQueue: ITurno[] = [];
  let promiseQueue: Promise<void> = Promise.resolve();

  useEffect(() => {
    const id = setInterval(() => {
      setDate(new Date().toLocaleDateString() + '|' + new Date().toLocaleTimeString());
    }, 1000);

    return () => {
      clearInterval(id);
    }
  }, []);

  const showCall = (turno: ITurno): Promise<void> => {
    return new Promise((resolve) => {
      console.log("Inicio de turno", new Date().toLocaleTimeString());
      setIsCalling(true);
      setCurrentTurno(turno);
      const message = new SpeechSynthesisUtterance(turno.text);
      window.speechSynthesis.speak(message);

      setTimeout(() => {
        setIsCalling(false);
        setCurrentTurno(null);
        resolve();
        console.log("Fin de turno", new Date().toLocaleTimeString());
      }, 10000); 
    });
  };

  const enqueueProcessQueue = () => {
    promiseQueue = promiseQueue.then(() => processQueue());
  };

  const processQueue = async () => {
    if (callQueue.length > 0 && !isProcessingQueue) {
      setIsProcessingQueue(true);  
      console.log("Cola", callQueue.length);
      while (callQueue.length > 0) {
        const turno = callQueue.shift();
        console.log("Turno", turno);
        if (turno) {
          await showCall(turno);
        }
      }  
      setIsProcessingQueue(false);
    }
  };

  const onTurnosUpdate = (message: ITvMessage) => {
    console.log("onTurnosUpdate:", message);
    if (message != null) {
      const items = message.items || [];
      setTurnos(items);

      if (items.length > 0) {
        if (!message.silentMode) {
          const callingItems = items.filter(item => item.isCalling); // Filtra los turnos que tienen isCalling = true
          callQueue.push(...callingItems);
          setTurnoIsCalling(prev => [...prev, ...callingItems]);
          enqueueProcessQueue();
        }
      }
    }
  }

  const speak = (text: string) => {
    window.speechSynthesis.cancel();
  
    const utterance: SpeechSynthesisUtterance = new SpeechSynthesisUtterance(text);
  
    const loadVoices = () => {
      const voices = window.speechSynthesis.getVoices();
      const voice = voices.find(v => v.lang === 'es-ES');
  
      if (voice) {
        utterance.voice = voice; // ios required
        utterance.lang = voice.lang; // Android Chrome required
        // utterance.voiceURI = voice.voiceURI; // Removed as it does not exist on SpeechSynthesisUtterance
        utterance.pitch = 1;
        utterance.volume = 1;
        utterance.rate = 1;
        window.speechSynthesis.speak(utterance);
      } else {
        console.error("No hay voz cargada");
        playCallingSound();
      }
    };
  
    // Escuchar el evento voiceschanged si las voces aún no están cargadas
    if (window.speechSynthesis.getVoices().length === 0) {
      window.speechSynthesis.addEventListener('voiceschanged', loadVoices);
    } else {
      loadVoices(); // Ya están cargadas
    }
  }

  const playCallingSound = () => {
    const iframe = document.createElement('iframe');
    iframe.src = './calltoAttention.mp3';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    // Eliminar el iframe después de 5 segundos
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 5000);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paramValue = params.get('sucursal'); // Cambia 'myParam' por el nombre de tu parámetro
    const url = (window as any).masHub;

    if(paramValue !== null)
    {
      const connection = new signalR.HubConnectionBuilder().withUrl(`${url}/tv`).withAutomaticReconnect().build();
      setConnection(connection);

      connection.start().then(o => {
        setIsConnected(true);
        connection.on("OnTvConnected", () => setIsConnected(true));
        connection.on("OnTvConnected", () => setIsReady(true));
        connection.on('OnTurnosUpdate', onTurnosUpdate);
        connection.invoke('RegisterTV', paramValue);
      }).catch(ex => setConnectionError(ex));

      speak("Conectado");
      return () => {
        connection?.stop();
      };
    }

  }, []);

  return isConnected
    ? isReady
      ? <>
        <div className='tv'>
          <div className='header'>
            {client === "MDN" &&
              <img
                src="https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/clients/mdn/logo-tv.png"
                style={{
                  height: '80px',
                  margin: '10px'
                }}
              />
            }
            {(client === "Divri" || client === "Divri2") &&
              <img
                src="https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/clients/divri/thumbnail_Logo-DIVRI-.png"
                style={{
                  height: '100px',
                  margin: '10px'
                }}
              />
            }
          </div>
          <div className='content'>
            {client === "MDN" && <>
              <div className='multimedia-mdn' style={{ userSelect: 'none', boxShadow: '0px 0px 5px 2px #020202' }}>
                <ReactPlayer
                  url={"https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/clients/mdn/VID-20230712-WA0000.mp4"}
                  playing={true}
                  loop={true}
                  controls={true}
                  width={'100%'}
                  height={'100%'}
                />
              </div>
              <div className='items'>
                {
                  turnos.map((turno) => <TurnoItem value={turno} />)
                }
              </div>
            </>
            }
            {client === "Divri" && <>
              <div className='multimedia' style={{ userSelect: 'none', boxShadow: '0px 0px 5px 2px #020202' }}>
                <ReactPlayer
                  url={"https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/clients/divri/prueba-digiturno.mp4"}
                  playing={true}
                  loop={true}
                  controls={true}
                  width={'100%'}
                  height={'100%'}
                />
              </div>
              <div className='items'>
                {
                  turnos.map((turno) => <TurnoItem value={turno} />)
                }
              </div>
            </>
            }
            {client === "Divri2" && <>
              <img className='multimedia'
                src="https://ioipcorestorageaccount.blob.core.windows.net/ioip-core-static-files/clients/divri/DIGITURNO thumbnail_Imagen_pq.jpg"
              />
              <div className='items' style={{ paddingLeft: 70 }}>
                {
                  turnos.map((turno) => <TurnoItem value={turno} />)
                }
              </div>
            </>
            }

          </div>
          <div className='footer'>
            <div className='footer-table'>
              <div data-role="row">
                <div data-role="cell" className='time-cell'>
                  {date.split('|')[1] || ''}
                  <br />
                  {date.split('|')[0] || ''}
                </div>
                {(client === "Divri" || client === "Divri2") &&
                  <div data-role="cell" style={{ width: 'calc(100% - 120px)' }}>
                    <div className='marquee'>
                      <div className="marquee">
                        {<p style={{ paddingTop: '6px' }}> Síguenos a través de redes sociales como @divriveteranos o visita nuestro sitio web www.divri.gov.co #JuntosPorNuestrosVeteranos</p>}
                      </div>
                    </div>
                  </div>
                }
                {client === "MDN" &&
                  <div data-role="cell" style={{ width: 'calc(100% - 120px)' }}>
                    <div className='marquee'>
                      <div className="marquee">
                        {<p style={{ paddingTop: '6px' }}>La Oficina de Relación con el Ciudadano cuenta con la sala Denuncia Segura a través de la cual usted podrá interponer denuncias protegiendo la identidad del denunciante y tramitando de forma efectiva su solicitud, nuestro horario de atención en días hábiles son de Lunes a Viernes de 8:00 am a 5:00 pm jornada continua, así mismo puede radicar Derechos de Petición de competencia del Sector Defensa y recibir atención personalizada. También puede realizar sus solicitudes al correo usuarios@mindefensa.gov.co y comunicarse con nosotros a través de la línea gratuita nacional 018000954513.</p>}
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        {isCalling && currentTurno && <TurnoMain key={currentTurno.id} turno={currentTurno} />}
      </>
      : <div>
        <h1>Cargando...</h1>
      </div>
    : <div>
      <h1>Desconectado</h1>
    </div>
}

export default App;
